import cn from "classnames";
import React, { FC } from "react";
import styled from "styled-components";

const StyledHeaderAvatar = styled.button`
  width: 40px;
  height: 40px;

  border: none;
  padding: 0;
  background: none;

  cursor: pointer;

  .HeaderAvatar__name {
    width: 100%;
    height: 100%;

    display: flex;
    justify-content: center;
    align-items: center;

    font-weight: bold;
    font-size: 16px;
    line-height: 21px;
    text-transform: uppercase;

    background: ${({ theme }) => theme.colors.white};
    border-radius: 50%;
  }

  &.HeaderAvatar_dark .HeaderAvatar__name {
    background: #111111;
    color: ${({ theme }) => theme.colors.yellow};
  }
`;

interface Props {
  className?: string;
  name?: string;
  variant?: "light" | "dark";
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  "data-cy"?: string;
}

// Initials only, never the Auth0 profile photo - matches the avatar in the
// User Settings drawer, and mobile's own equivalent fix.
const HeaderAvatar: FC<Props> = ({
  className,
  name,
  variant = "light",
  onClick,
  "data-cy": dataCy,
}) => {
  const initials =
    variant === "dark"
      ? name
          ?.split(" ")
          .slice(0, 2)
          .map((word) => word[0])
          .join("")
      : name?.slice(0, 1);

  return (
    <StyledHeaderAvatar
      className={cn(className, { HeaderAvatar_dark: variant === "dark" })}
      onClick={onClick}
      data-cy={dataCy}
    >
      <div className="HeaderAvatar__name">{initials}</div>
    </StyledHeaderAvatar>
  );
};

export { HeaderAvatar };
